import {Component, EventEmitter, Output, Input, ChangeDetectorRef} from '@angular/core';
import {Observable} from 'rxjs';
import {GenericCrudService} from '../../services/generic-crud.service';
import {ChangeDetectorRefHelper} from '../../helpers/change-detector-ref.helper';

interface Customer {
  primaryName: string;
  secondaryName: string;
}

@Component({
  selector: 'app-customer-autocomplete',
  template: `    
    <p-autoComplete
      appAutocomplete
      appendTo="body"
      field="label"
      [placeholder]="'---'"
      [dropdown]="true"
      [(ngModel)]="selectedOption"
      [suggestions]="options"
      (onKeyUp)="onKeyUp($event)"
      (completeMethod)="onSearch($event)"
      (onDropdownClickNoQuery)="onSearch($event)"
      (onSelect)="onCustomerChanged($event)"
    ></p-autoComplete>
  `,
  styles: [`
    p-autocomplete ::ng-deep .ui-autocomplete-input {
      width: calc(100% - 26px); // dropdown button
    }
  `]
})
export class CustomerAutocompleteComponent {

  @Input() public params = {};
  @Input() public apiRoute = 'phoenix/customers';
  @Input() public selectedOption: SelectItem = null;
  @Output() public onCustomerOptionChanged: EventEmitter<Customer> = new EventEmitter();

  public options: SelectItem[] = [];

  public constructor(
    protected readonly genericCrudService: GenericCrudService,
    public cdr: ChangeDetectorRef
  ) {
  }

  public onKeyUp(event): void {
    if (!event.target.value) {
      this.onCustomerOptionChanged.emit(null);
    }
  }

  public onSearch(event: {query: string}): void {
    this.loadCustomers(event.query)
      .subscribe((paginated: {data: Customer[]}) => {
        const data = paginated instanceof Array ? paginated : paginated.data;

        this.options = [];

        for (const customer of data) {
          this.options = [...this.options, {
            label: customer.primaryName + ' ' + customer.secondaryName,
            value: customer
          }];
        }

        ChangeDetectorRefHelper.detectChanges(this);
      });
  }

  public onCustomerChanged(event?: {value: any}): void {
    this.onCustomerOptionChanged.emit(this.selectedOption.value);
  }

  private loadCustomers(query): Observable<any> {
    const params = this.params;

    params['embedded'] = 'none';
    params['clause'] = 'orWhere';

    return this.genericCrudService.getEntities(
      this.apiRoute + '/offset/0/limit/30/orderby/id/asc?search=' + query,
      '',
      params
    );
  }
}

